import React from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  return <section className="py-20 md:py-32 bg-ink relative" data-id="element-397" data-mp="1oln3qkdat87r">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl text-center" data-id="element-398" data-mp="1ol4ywzckllo8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-399" data-mp="23hcibxg5mj2g">
          <p className="text-xl md:text-2xl text-cream font-light leading-relaxed" data-id="element-400" data-mp="1kkbcybiougxz">
            Hay un momento en cada celebración que nadie puede planear.
          </p>

          <p className="text-xl md:text-2xl text-cream font-light leading-relaxed" data-id="element-401" data-mp="1fr8eboz20hax">
            Es ese segundo en que tu mamá te abraza sin decir nada.
          </p>

          <p className="text-xl md:text-2xl text-cream font-light leading-relaxed" data-id="element-402" data-mp="n3w2o9ufltwe">
            O cuando tu hija te mira con los ojos llenos de lágrimas antes de su
            primer vals.
          </p>

          <p className="text-xl md:text-2xl text-cream font-light leading-relaxed" data-id="element-403" data-mp="39fone3bqhy2g">
            O cuando la abuela — la que viajó desde lejos, la que no sabías si
            iba a poder venir — te toma de la mano y te dice:{' '}
            <span className="font-serif italic" data-id="element-404" data-mp="2mh1wk7no49c6">
              "Qué orgullosa estoy de ti."
            </span>
          </p>

          <p className="text-2xl md:text-3xl font-serif text-gold pt-4" data-id="element-405" data-mp="2qi40h1sj59kh">
            Ese momento dura tres segundos.
          </p>

          <p className="text-xl md:text-2xl text-cream font-light leading-relaxed" data-id="element-406" data-mp="2vg5g1cqqyqr7">
            Y si no lo capturas… desaparece para siempre.
          </p>

          <div className="py-6 space-y-4 text-cream/80" data-id="element-407" data-mp="arrebq5dpp2a">
            <p data-id="element-408" data-mp="ar99i54ni2ir">
              No estará en los videos de Instagram — que se ven una vez y se
              olvidan entre memes y reels.
            </p>
            <p data-id="element-409" data-mp="3m71m0om3j4wn">
              No aparecerá en el álbum digital — que prometiste imprimir y que
              sigue pendiente dos años después.
            </p>
          </div>

          <p className="text-xl md:text-2xl text-cream font-light leading-relaxed" data-id="element-410" data-mp="mgs4fmqp9s">
            El tiempo pasa. Los eventos terminan. Y lo que queda son los
            recuerdos.
          </p>

          <p className="text-xl md:text-2xl text-cream font-medium leading-relaxed" data-id="element-411" data-mp="33hcu74djk4li">
            ¿Pero cuántos recuerdos reales — tangibles, físicos, que se puedan
            tocar — tienes de los eventos más importantes de tu vida?
          </p>

          <div className="pt-8" data-id="element-412" data-mp="3d7y2xkmxipi5">
            <p className="font-script text-5xl md:text-6xl text-gold" data-id="element-413" data-mp="3d992175fj92x">
              Pero nosotros sí.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}